// extracted by mini-css-extract-plugin
module.exports = {"row_wrapper":"BranchDetailsStatus_row_wrapper__KLR8w","result":"BranchDetailsStatus_result__jTpUN","link_for_branch":"BranchDetailsStatus_link_for_branch__4Be_a"};